import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import { Dialog, DialogContent } from "@ui-kit/Dialog";
import { useCallback, useState } from "react";
import { GesCloudSignIn } from "../../../enterpriseCommon/components/signIn/GesCloudSignIn";
import { GesCloudSignInHeader } from "../../../enterpriseCommon/components/signIn/GesCloudSignInHeader";
import { GesCorporateSignIn } from "./GesCorporateSignIn";

interface SignInEnterpriseTauriFormProps {
	gesCloudUrl?: string;
}

export const SignInEnterpriseTauriForm = ({ gesCloudUrl: gesCloudUrlProp }: SignInEnterpriseTauriFormProps) => {
	const [open, setOpen] = useState(true);
	// biome-ignore lint/correctness/useExhaustiveDependencies: it's ok
	const onOpenChangeHandler = useCallback(
		(value: boolean) => {
			setOpen(value);
			if (!value) ModalToOpenService.resetValue();
		},
		[setOpen],
	);

	return (
		<Dialog onOpenChange={onOpenChangeHandler} open={open}>
			<DialogContent data-modal-root>
				<GesCloudSignIn
					className="p-4"
					corporateSignIn={<GesCorporateSignIn />}
					gesCloudUrl={gesCloudUrlProp && URL.canParse(gesCloudUrlProp) ? gesCloudUrlProp : undefined}
					header={<GesCloudSignInHeader />}
				/>
			</DialogContent>
		</Dialog>
	);
};
